import { Alert, Avatar, Box, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { MailOutline as MailIcon } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import BotonVolver from "../../components/kit/BotonVolver";
import { useEstudiante } from "../../queries/useEstudiantes";
import ProcesosEstudiante from "../../components/app/ProcesosEstudiante";

/**
 * Procesos de un estudiante vistos por el staff (guía/coguía/revisor): el mismo
 * stepper que ve el propio estudiante, en modo lectura. Se llega presionando una
 * fila en la vista de Procesos. El backend gatea el acceso (staff/guía/evaluador).
 */
export default function ProcesoEstudianteVista() {
  const { rut } = useParams();
  const { data, isLoading, isError } = useEstudiante(Number(rut));

  return (
    <Box>
      <BotonVolver fallback="/app" />

      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}
      {isError && <Alert severity="error">No se pudo cargar (¿tienes permiso para ver este estudiante?).</Alert>}

      {data && (
        <>
          <Paper elevation={0} sx={{ p: 3, mb: 3, border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
            <Stack direction="row" spacing={2} alignItems="flex-start">
              <Avatar src={data.foto ?? undefined} sx={{ width: 64, height: 64, flexShrink: 0 }}>
                {data.nombre.charAt(0)}
              </Avatar>
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="h4">{data.nombre}</Typography>
                <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ mt: 1, color: "text.secondary" }}>
                  <Typography variant="body2">RUT {data.rut}</Typography>
                  {data.email && (
                    <Typography variant="body2" sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                      <MailIcon fontSize="inherit" /> {data.email}
                    </Typography>
                  )}
                </Stack>
              </Box>
            </Stack>
          </Paper>

          {data.instancias.length === 0 ? (
            <Paper elevation={0} sx={{ p: 4, textAlign: "center", border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
              <Typography color="text.secondary">Este estudiante no tiene procesos registrados.</Typography>
            </Paper>
          ) : (
            <ProcesosEstudiante instancias={data.instancias} soloLectura />
          )}
        </>
      )}
    </Box>
  );
}
